import { useQuery } from 'react-query';
import { fetchUnreviewedRatingFeedback } from 'services/api/concierge.api.service';

export const unreviewedRatingFeedbackQueryKey = 'unreviewed-rating-feedback';
export default () =>
  useQuery(unreviewedRatingFeedbackQueryKey, fetchUnreviewedRatingFeedback, {
    staleTime: 10 * 60 * 1000,
  });
